import { render, staticRenderFns } from "./UpdateControllerTypeModal.vue?vue&type=template&id=0d5888bd&"
import script from "./UpdateControllerTypeModal.vue?vue&type=script&lang=js&"
export * from "./UpdateControllerTypeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports